import { onMounted, ref } from 'vue';
import { useSettings } from './use.settings.js';
import { set } from '@vueuse/core';

export function useSelectedCategory(loadProducts: (ids: number[]) => Promise<void>) {
  const selectedCategory = ref<string | null>(null);
  const { refreshSettings, settings } = useSettings();

  async function selectCategory(label: string, products?: number[]) {
    products ??= settings.value?.collection_groups.find((g) => g.label === label)?.products;

    if (!products) {
      return;
    }

    await loadProducts(products);
    set(selectedCategory, label);
  }

  onMounted(async () => {
    refreshSettings();
    const defaultCategory = settings.value?.default_checked_tag ?? settings.value?.collection_groups[0]?.label;

    if (defaultCategory) {
      await selectCategory(defaultCategory);
    }
  });

  return { selectedCategory, selectCategory };
}
